module.exports = __webpack_public_path__ + "static/fonts/RaisonnePro-Regular.3701af3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/RaisonnePro-Regular.ttf
// module id = VYNO
// module chunks = 18